import React from 'react';
import { useState, useEffect } from "react"
import BasicCard from "../../../components/basics/cards/BasicCard"
import FilterSettings from '../../../components/FilterSettings'
import AlertMessage from "../../../components/AlertMessage";
import { TokenService } from '../../../services/TokenService'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import CommentDetails from './CommentDetails';
import CommentsTable from './CommentsTable';
import { ResultsAndCommentAPIService } from "../../../services/apis/ResultsAndCommentAPIService";
import './results-comments.css';

function ResultsAndComments() {
    const controllerName = "ResultsAndComments";
    const user = TokenService.getUser();
    var username = "";
    if (user != null && user.account.username != null) {
        username = user.account.username
    }
    const [updatingFilter, setUpdatingFilter] = useState(false)
    const [filterArray, setFilterArray] = useState(0);
    const [nodeVersionCommentId, setNodeVersionCommentId] = useState(0);
    const [resultsAndCommentsValue, setResultsAndCommentsValue] = useState('');
    const [periodId, setPeriodId] = useState('');
    const [nodeId, setNodeId] = useState('');
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });

    const [pageConfig, setPageConfig] = useState({
        pageSettings: { name: "Results and comments" },
        controllerName: controllerName,
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: ""
    });

    useEffect(() => {
        const selectedPeriodId = filterArray ? filterArray[0].value : 0
        setPeriodId(selectedPeriodId)

        const selectedNodeId = filterArray ? filterArray[1].value : 0
        setNodeId(selectedNodeId)

        if ((nodeId !== selectedNodeId && selectedNodeId !== 0) || periodId !== selectedPeriodId && selectedPeriodId !== 0) {
            fetchResultsAndComments(selectedPeriodId, selectedNodeId);
        }
    }, [filterArray, username])

    const fetchResultsAndComments = (periodId, nodeId) => {
        setResultsAndCommentsValue([]);
        ResultsAndCommentAPIService.giveResultsAndCommentsValues(nodeId, periodId)
            .then(data => {
                setNodeId(nodeId);
                setPeriodId(periodId);
                setResultsAndCommentsValue(data);
                setUpdatingFilter(false);
            });
    };

    const handleSave = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });
        var periodId = filterArray ? filterArray[0]['value'] : 0;
        var nodeId = filterArray ? filterArray[1]['value'] : 0;
        var comment = document.getElementById("comments").value;

        if (periodId == 0 || nodeId == 0 || comment == "") {
            setAlertObject({ variant: 'danger', alertMessage: 'Please choose a period, entity and group, version and add the comment to save.' })
            return false;
        }
        ResultsAndCommentAPIService.saveNodeVersionComment(comment, periodId, nodeId, nodeVersionCommentId)
            .then(response => {
                setAlertObject({ variant: 'success', alertMessage: "Comments have been successfully saved." });
                // Fetch updated results and comments after save
                fetchResultsAndComments(periodId, nodeId);
            }
        );
    }

    const handleSubmitAndFreeze = (e) => {
        e.preventDefault();

        setAlertObject({ variant: '', alertMessage: '' });
        var periodId = filterArray ? filterArray[0]['value'] : 0;
        var nodeId = filterArray ? filterArray[1]['value'] : 0;

        if (periodId == 0 || nodeId == 0) {
            setAlertObject({ variant: 'danger', alertMessage: 'Please choose a period and entity and group.' })
            return false;
        }

        if (resultsAndCommentsValue?.dateFinal != null) {
            setAlertObject({ variant: 'danger', alertMessage: 'Data is already finalized.' })
        }
        else {

            ResultsAndCommentAPIService.submitResultAndCommentView(periodId, nodeId).then(
                response => {
                    setAlertObject({ variant: 'success', alertMessage: "Submit was succesfull" });
                    fetchResultsAndComments(periodId, nodeId);
                }
            );
        }
    }
    const clearMessages = () => setAlertObject({ variant: '', alertMessage: '' });

    const handleCalculateScenario = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });
        var periodId = filterArray ? filterArray[0]['value'] : 0;
        var nodeId = filterArray ? filterArray[1]['value'] : 0;

        if (periodId == 0 || nodeId == 0) {
            setAlertObject({ variant: 'danger', alertMessage: 'Please choose a period and entity and group.' })
            return false;
        }
        ResultsAndCommentAPIService.calculateStressResults(periodId, nodeId).then(
            response => {
                setAlertObject({ variant: 'success', alertMessage: "Calculation was succesfull" });
                fetchResultsAndComments(periodId, nodeId);
            }
        );
    }

    const handleReset = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });

        var periodId = filterArray ? filterArray[0]['value'] : 0;
        var nodeId = filterArray ? filterArray[1]['value'] : 0;

        if (periodId == 0 || nodeId == 0) {
            setAlertObject({ variant: 'danger', alertMessage: 'Please choose a period and entity and group.' })
            return false;
        }

        ResultsAndCommentAPIService.resetResultsAndCommentsView(periodId, nodeId).then(
            response => {
                setAlertObject({ variant: 'success', alertMessage: "Reset was succesfull" });
                fetchResultsAndComments(periodId, nodeId);
            }
        );
        setAlertObject({ variant: 'success', alertMessage: "Reset was succesfull" });
    }

    return (
        <BasicCard cardConfig={{ cardTitle: 'Results and comments', cardHeadingElement: 'h4' }} >
            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}
            <FilterSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} clearMessages={clearMessages} />
            <BasicCard cardConfig={{ cardTitle: 'Comment', cardHeadingElement: 'h5' }}>
                <Container>
                    <Row md={2 }>
                        {/*Column for details*/}
                        <Col>
                            <CommentDetails resultsAndCommentsValue={resultsAndCommentsValue} />
                        </Col>
                        <Col>
                            <CommentsTable resultsAndCommentsValue={resultsAndCommentsValue} />
                        </Col>
                    </Row>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                        <Button href='#' onClick={clearMessages}>Cancel</Button>
                        <Button variant='primary' className='node-admin-save' onClick={handleSave} style={{ marginLeft: '0.5rem' }}>Save</Button>
                        <Button disabled={(resultsAndCommentsValue?.dateFinal === 'undefined')} onClick={handleSubmitAndFreeze} style={{ marginLeft: '0.5rem' }}>Submit / Freeze</Button>
                        <Button onClick={handleReset} style={{ marginLeft: '0.5rem' }}>Reset</Button>
                        <Button onClick={handleCalculateScenario} style={{ marginLeft: '0.5rem' }}>Calculate scenario(s)</Button>
                    </div>
                </Container>
            </BasicCard>
        </BasicCard>
    );
}

export default ResultsAndComments;